import FinderViewBase from '../FinderViewBase/FinderViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AppointmentToDoListEditor.html?raw';
import "./AppointmentToDoListEditorTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import ToDoListEditor from './ToDoListEditor/ToDoListEditor';
import "./ToDoListEditor/ToDoListEditor";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';


interface evBookingData {
    ID: string;
    date_end: Date;
    date_start: Date;
    ev_booking_name: string;
    ref_ev_activity_status: {
        ID: string;
        description: string;
        coloration: more.EntityAPIColor;
    }
    ref_ev_room: {
        ID: string;
        description: string;
        ref_venue: {
            ID: string;
            description: string;
        }
    }
    tmp_todo_appointment_info: string;
    tmp_todo_appointment_progress_status: string;
}
class AppointmentToDoListEditor extends compose(FinderViewBase) {
	templateString: any = template;

    calendarContainer: HTMLElement; // will be passed as a function parameter
    tableContainer: HTMLElement; // will be passed as a function parameter

    genericDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;

    _isCalendarctive: boolean;
    _isTableActive: boolean;
    buttonClickTimeout: number = null;

    // damit man die Name und containerNode im Bedarfsfall nur an einer Stelle ändern muss
    bookingsCalendarParams: calendarParams = { sContainerNodeName: "calendarContainer", domNodeHeight: 500, showButtons: true };
    bookingsTableParams: tableParams = { widgetName: "bookingsTable", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "items";
    tableEntityPath = "Entity";
    loadFilterDatatUrl = "AppointmentToDoListEditor/GetEventList";
    loadFinderConfigUrl = "AppointmentToDoListEditor/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["AddressFinder_BtnSubmitNext"];
    btnSubmitLabelText = (this as any).translations["AddressFinder_BtnSubmit"];
    calendar_columnViewHeadTextAttr: string = "barview_text"; 
    calendar_columnViewBodyTextAttr: string = "columnview_head_text"; 


    bookingTable_formatterFunction(cell: StaticTable.StaticTableCell<evBookingData>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            case "actions":
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": this.translations["Generic_show"],
                    "class": "mds-button-base round w3-center sL3 mds-hover-dark w3-large",
                    "onclick": lang.hitch(this, "tableRowButton_click_showInCalendar", cell.tableRow),
                    "title": this.translations["Generic_show"],
                }, node);

                this.UiModder.domConstruct.create("I", { "class": "far fa-calendar-alt" }, btn);

                // todo liste vrewalten
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": this.translations["Generic_manage"],
                    "class": "mds-button-base round w3-center pL3 mds-hover-dark w3-large w3-margin-left",
                    "onclick": lang.hitch(this, this.showTodoEditor, { entity: entity }),
                    "title": this.translations["Generic_manage"]
                }, node);

                this.UiModder.domConstruct.create("I", { "class": "fas fa-clipboard-list" }, btn);
                return true;
                break;

            default:
                return false;
        }
    }

    genericDialog_closeFunction = function (result?: any): void {
        if ((this as any)._is_dlg_active && (this as any).modalDlgNode) {
            let close_unsaved: boolean = true;

            if ((this as any).toDoListEditor.unsavedRows.length > 0) {
                close_unsaved = confirm((this as any).translations["AppointmentToDoListEditor_unsavedChanges"]);
            }

            if (close_unsaved == true) {
                (this as any).UiModder.domStyle.set((this as any).modalDlgNode, "display", "none");

                if (typeof (result) == "undefined") {
                    result = 0;
                } else if (typeof (result) == "function") {
                    result();
                }

                setTimeout(lang.partial((this as any).callback, result), 1);

                if ((this as any).destroyOnClose === true) {
                    setTimeout(lang.hitch(this, "destroy"), 1000);
                }

                (this as any).emit("closed", { result: result });
            }
        }
    }
    // -------------------------------------- METHODS -----------------------------------------------
    // overrides -----------------------------------------------start
    filterOptions_additionalConfig(): void { //Base
        // weil am anfang die tabelle ausgewählt ist
        let displayDateOption = this.getFilterOptionByName("displayDate");
        if (displayDateOption) {
            displayDateOption.set("readonly", true);
            displayDateOption.on("change", lang.hitch(this, function () {
                console.log(displayDateOption, this.calendar)
                if (this.calendar) {
                    this.calendar.setDate(displayDateOption.getValue())
                }
            }))
        }

        let highLightOption = this.getFilterOptionByName("highlightItems");
        if (highLightOption) {
            highLightOption.set("readonly", true);
            highLightOption.on("change", lang.hitch(this, function (change) {
                this._onCalenderHighlightItemChange(highLightOption.getValue());
                setTimeout(lang.hitch(this, function () { this.checkDirtyState(false); }), 170)
            }))
        }


        let viewOption = this.getFilterOptionByName("view")
        if (viewOption) viewOption.on("change", lang.hitch(this, function () {
            this._onViewChange(viewOption)
        }))
    }

    _onViewChange(option) {
        let displayDateOption = this.getFilterOptionByName("displayDate");
        let startTimeOption = this.getFilterOptionByName(this.filterOptionDateStart);
        let endTimeOption = this.getFilterOptionByName(this.filterOptionDateEnd);
        let tableLayoutOption = this.getFilterOptionByName("tableLayout");
        let highLightOption = this.getFilterOptionByName("highlightItems");
        let calendarItemsColoration = this.getFilterOptionByName("calendarItemsColoration")
        switch (option.data.value) {
            case "calendar":
                this.showCalendar(true);
                if (displayDateOption) displayDateOption.set("readonly", false);
                if (highLightOption) highLightOption.set("readonly", this.calendar && this.calendar.lastHighlightedCalendarItem_ID == null);
                if (startTimeOption) startTimeOption.set("readonly", true);
                if (endTimeOption) endTimeOption.set("readonly", true);
                if (tableLayoutOption) tableLayoutOption.set("readonly", true);
                if (calendarItemsColoration) calendarItemsColoration.set("readonly", false)
                break;
            case "table":
                this.showTable(true, false);
                if (displayDateOption) displayDateOption.set("readonly", true);
                if (highLightOption) highLightOption.set("readonly", true); highLightOption.set("value", false);
                if (startTimeOption) startTimeOption.set("readonly", false);
                if (endTimeOption) endTimeOption.set("readonly", false);
                if (tableLayoutOption) tableLayoutOption.set("readonly", false);
                if (calendarItemsColoration) calendarItemsColoration.set("readonly", true)
                break;
        }
    }

    /*
    // Evens der Filterpanel fangen
    _onOptionValueChange(dataObj: filterPanel_option_valuechange_obj): void { //Base

        if (dataObj) {
            if (dataObj.name == "resultviewParameter") {
                switch (dataObj.option) {
                    case "view":
                        if (dataObj.optionValue == "calendar") {

                            let startTimeOption = this.getFilterOptionByName("startTime");
                            let endTimeOption = this.getFilterOptionByName("endTime");
                            if (startTimeOption) startTimeOption.set("readonly", true);
                            if (endTimeOption) endTimeOption.set("readonly", true);
                            let displayDateOption = this.getFilterOptionByName("displayDate");
                            if (displayDateOption) displayDateOption.set("readonly", false);
                            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
                            if (tableLayoutOption) tableLayoutOption.set("readonly", true);
                            let colorationOption = this.getFilterOptionByName("calendarItemsColoration");
                            if (colorationOption) colorationOption.set("readonly", false);
                            if (this._isTableActive) this.showCalendar();

                        } else if (dataObj.optionValue == "table") {

                            let startTimeOption = this.getFilterOptionByName("startTime");
                            let endTimeOption = this.getFilterOptionByName("endTime");
                            if (startTimeOption) startTimeOption.set("readonly", false);
                            if (endTimeOption) endTimeOption.set("readonly", false);
                            let displayDateOption = this.getFilterOptionByName("displayDate");
                            if (displayDateOption) displayDateOption.set("readonly", true);
                            let highlightItemsOption = this.getFilterOptionByName("highlightItems");
                            if (highlightItemsOption) {
                                highlightItemsOption.set("value", false);
                                highlightItemsOption.set("readonly", true);
                            }
                            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
                            if (tableLayoutOption) tableLayoutOption.set("readonly", false);
                            let colorationOption = this.getFilterOptionByName("calendarItemsColoration");
                            if (colorationOption) colorationOption.set("readonly", true);
                            if (this._isCalendarctive) this.showTable(true, true);
                        }
                        break;
                    case "tableLayout":

                        if (this._isTableActive) this.createTable(this.bookingsTableParams.widgetName, this[this.bookingsTableParams.sContainerNodeName], dataObj.optionValue, this._completeList, this.bookingTable_formatterFunction);

                        break;
                    case "displayDate":
                        if (this.bookingsCalendarParams) {
                            if (this.calendar && this._isCalendarctive) this.calendar.setDate(dataObj.optionValue);
                        } else {
                            alert("calenadr params?")
                        }
                        break;
                    case "highlightItems":
                        if (this.bookingsCalendarParams) {
                            this._onCalenderHighlightItemChange(dataObj.toggleSelected);
                        } else {
                            alert("calenadr params?")
                        }
                        break;
                }
            } else if (dataObj.name == "searchParameter") {
                switch (dataObj.option) {
                    case "searchText":
                        if (this._isCalendarctive == true) {
                            this.dateRangeStart = null;
                            this.dateRangeEnd = null;
                        }
                        break;
                }
            }
        }
    }
    */

    _onClick_Submit(evt: Event) { // Base

        if (this._isRequestActive === true || (this.getDirty() != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        var viewSelectOption = this.getFilterOptionByName("view"); 
        if (viewSelectOption) {
            
            if (viewSelectOption.getValue() == "calendar") {
                this.showCalendar();
            } else if (viewSelectOption.getValue() == "table") {
                this.showTable();
            }
        } else {
            alert("No View selected");
        }
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.bookingsTableParams) {
            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
            let selectedLayout: string = <string>tableLayoutOption.getValue();

            // z.B. gleich eine Tabelle kreieren
            let table = this.createTable(this.bookingsTableParams.widgetName, this[this.bookingsTableParams.sContainerNodeName], selectedLayout, this._completeList, this.bookingTable_formatterFunction);
            table.setRowClick(lang.hitch(this, this.showTodoEditor))
            this.checkDirtyState(false);
        } else {
            alert("table params?");
            return;
        }

        //this.setTaskProgressStyles(); // nimmer nötig -> kommt aus Tablelayout und API

        
    }
    // --------------overrides ------------------------------------end
    // --------------------own methods ----------------------------start

    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    showTable(bool?: boolean, useLastResponse?:boolean): void {
        if (this.bookingsTableParams) {
            if (bool === false) {
                if (this._isTableActive) {
                    if (this[this.bookingsTableParams.sContainerNodeName]) {
                        this.UiModder.domClass.add(this[this.bookingsTableParams.sContainerNodeName], "w3-hide");
                        if (this._isCalendarctive == false) this.showCalendar();
                        this._isTableActive = false;
                    } else {
                        console.log("no DomNode found for this.", this.bookingsTableParams.sContainerNodeName)
                    }
                }
            } else {
                if (this._isTableActive) {
                    this.removeWidgetByName(this.bookingsTableParams.widgetName);
                    this[this.bookingsTableParams.sContainerNodeName].innerHTML = null;
                }
                if (useLastResponse) {
                    this.processFilterListResponse(this.lastResponse);
                } else {
                    this.getFilterlist();
                }
                this._isTableActive = true;
                if (this._isCalendarctive) this.showCalendar(false);
            }
        } else {
            alert("calendar params?")
        }
    }

    //setTaskProgressStyles(): void {
    //    let bookingTable: StaticTable = this.getWidgetByName(this.bookingsTableParams.widgetName);
    //    bookingTable.setRowClass_Based_On_EntityProperty("tmp_todo_appointment_progress_status", "inProgress", "inProgressColoration");
    //    bookingTable.setRowClass_Based_On_EntityProperty("tmp_todo_appointment_progress_status", "noneDone", "noneDoneColoration");
    //    bookingTable.setRowClass_Based_On_EntityProperty("tmp_todo_appointment_progress_status", "allDone", "allDoneColoration");
    //}

    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    private showCalendar(bool?: boolean): void {
        console.debug("showCalendar", this.bookingsCalendarParams);
        if (this.bookingsCalendarParams) {

            if (bool === false) {
                if (this._isCalendarctive) {
                    if (this[this.bookingsCalendarParams.sContainerNodeName]) {
                        this.UiModder.domClass.add(this[this.bookingsCalendarParams.sContainerNodeName], "w3-hide");
                        this._isCalendarctive = false;
                        if (this._isTableActive === false) this.showTable(true);

                    } else {
                        console.log("no DomNode found for this.", this.bookingsCalendarParams.sContainerNodeName)
                    }
                }
            } else {
                var displayDateOption = this.getFilterOptionByName("displayDate");
                var displayDate: string = null;
                if (displayDateOption && displayDateOption.selected && displayDateOption.getValue()) displayDate = <string>displayDateOption.getValue();

                this.createCalendar(
                    this[this.bookingsCalendarParams.sContainerNodeName],
                    this.bookingsCalendarParams.domNodeHeight,
                    this.bookingsCalendarParams.showButtons,
                    this.bookingsCalendarParams.calendarMode,
                    displayDate
                );

                this._isCalendarctive = true;
                if (this._isTableActive) this.showTable(false);
                this.calendar.setItemClickFunction(lang.hitch(this, this._onCalendarItemClick));
            }
        } else {
            alert("calendar params?")
        }
    }

    private _onCalendarItemClick(item, evt: MouseEvent): void {
        //console.debug("_onCalendarItemClick", item);
        let entity: evBookingData = item[this.tableEntityPath];
     
        if (entity) {
            this.showTodoEditor(entity);
        }

        if (evt) {
            evt.stopPropagation();
        }
    }

    // Die Angeklickte Entity im Kalender anzeigen
    private tableRowButton_click_showInCalendar(rowData: StaticTable.StaticTableRow<evBookingData>, evt: MouseEvent): void {
        let entity = rowData.rowGroup.entity;

        if (evt) {
            evt.stopPropagation();
        }

        let viewOption = this.getFilterOptionByName("view");
        if (viewOption) viewOption.set("value", "calendar");

        let highlightOption = this.getFilterOptionByName("highlightItems");
        if (highlightOption) {
            highlightOption.set("value", true);
            highlightOption.set("readonly", false);
        }

        if (this.buttonClickTimeout != null) {
            clearTimeout(this.buttonClickTimeout);
        }
        this.buttonClickTimeout = setTimeout(lang.hitch(this, function () {
            if (this.calendar) {
                this.calendar.setDate(entity.date_start);
                this.calendar.setItemToHighlight(entity.ID);
                this.showCalendar(true);
            }
        }), 500)
    }

    // instanziert das ToDoEdit mit der rowdata.Entity
    private showTodoEditor(data: StaticTable.StaticTableRow<evBookingData> | evBookingData): void {

        console.debug("showTodoEditor", data);
        let entity = data;
        let rowData = <StaticTable.StaticTableRow<evBookingData>>data;
        if (rowData.rowGroup) {
            entity = rowData.rowGroup.entity;
        } else {
            entity = <evBookingData>entity;
        }

        if (this.genericDialog != null) {
            this.genericDialog.destroy();
            this.genericDialog = null;
        }

        this.genericDialog = new GenericDialog();

        this.genericDialog.set("header", entity.ev_booking_name);

        let toDoListEditor = new ToDoListEditor();
        this.UiModder.domStyle.set(toDoListEditor.domNode, "min-height", "100px");

        this.genericDialog["toDoListEditor"] = toDoListEditor;
        toDoListEditor.placeAt(this.genericDialog.textNode);

        toDoListEditor.loadData(entity.ID);

        this.genericDialog.set("closeBtn", true);
        this.genericDialog.addButton("showAll",
            this.translations["AppointmentToDoListEditor__showAllTasks"],
            lang.hitch(this, "_onShowAllAppointmentsClick"),
            "",
            "accentBG", null, false);
        this.genericDialog.set("topCloseBtn", true);
        this.genericDialog.close = this.genericDialog_closeFunction;
        this.genericDialog.on("closed", lang.hitch(this, "_onToDoListEditorClose"));
        this.genericDialog.open();
    }


    private _onShowAllAppointmentsClick(): void {
        let showOpenOnly: boolean = this.genericDialog["toDoListEditor"].openToDos_only;
        this.genericDialog["toDoListEditor"].openToDos_only = !showOpenOnly;
        let button = this.genericDialog.getButtonByName("showAll");
        if (showOpenOnly == true) {
            if (button) {
                this.UiModder.domAttr.set(button.node, "innerHTML", this.translations["AppointmentToDoListEditor__showOnlyFinishedTasks"]);
            }
        } else {
            if (button) {
                this.UiModder.domAttr.set(button.node, "innerHTML", this.translations["AppointmentToDoListEditor__showAllTasks"]);
            }
        }

        this.genericDialog["toDoListEditor"].loadData(this.genericDialog["toDoListEditor"].bookingId)

        this.genericDialog["toDoListEditor"].setTaskProgressStyles();
    }

    // Je nach dem ob Tabelle oder Kalender aktiv sind, aktuelle Daten für die bestehende View  laden
    private _onToDoListEditorClose(): void {
        if (this._isTableActive) {

            this.setPage(this._currentPage, true);
        }
        if (this._isCalendarctive) {
            this.showCalendar();
        }
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AppointmentToDoListEditor);